<template>
  <div v-if="logInObj" class="modal__body">
    <BaseCaption :text="logInObj.title" tag="h3" />
    <form @submit.prevent="register">
      <BaseLabel :text="logInObj.emailLabel" forInput="emailLogin">
        <BaseField v-model="form.login" name="emailLogin" :class="[{'modal__field_error': errors.login}]"/>
        <BaseErrorMessage v-if="errors.login">
          {{ errors.login[0] }}
        </BaseErrorMessage>
      </BaseLabel>
      <BaseLabel :text="logInObj.passwordLabel" forInput="password">
        <BaseField v-model="form.pass" name="pass" type="password"  :class="[{'modal__field_error': errors.pass}]" />
        <BaseErrorMessage v-if="errors.pass">
          {{ errors.pass[0] }}
        </BaseErrorMessage>
      </BaseLabel>
      <div class="modal__container">
        <button class="btn  btn--default" type="submit">
          {{ logInObj.buttonLabel }}
        </button>
        <a class="link" href="#" @click.prevent="$emit('reset', true)">
          {{ logInObj.resetPasswordButtonLabel }}</a
        >
      </div>
      <div>
        <BaseText :text="logInObj.notRegisteredText" />
        <a class="link" href="#" @click.prevent="$emit('register', true)">
          {{ logInObj.registerButtonLabel }}</a
        >
      </div>
    </form>
  </div>
</template>

<script>
import { EventBus } from '~/plugins/eventBus.js'
import { mapActions, mapGetters } from 'vuex'
import AppPreloaderModal from '~/components/modals/AppPreloaderModal'

export default {
  data() {
    return {
      form: {
        login: '',
        pass: ''
      },
      errors: {},
      ready: false
    }
  },
  computed: {
    ...mapGetters({
      logInObj: 'common/logInModal'
    })
  },
  components: {
    AppPreloaderModal
  },
  methods: {
    ...mapActions({
      checkToken: 'auth/checkToken',
      loginUser: 'auth/loginUser'
    }),
    async register() {
      try {
        const { data } = await this.loginUser(this.form)
        this.$store.commit('common/TOGGLE_MODAL', false)

        const token = data.access_token

        document.cookie = `token=${token}`

        this.$store.commit('auth/SET_TOKEN', token)

        const response = await this.checkToken(token)
        const { user } = response.data

        this.$store.commit('auth/SET_USER', user)
        this.$store.commit('auth/SET_LOGIN', true)
      } catch ({ response }) {
        if (response.data.message) {
          this.errors = response.data.message
        }
      }
    }
  },
  async beforeCreate() {
    const { data } = await this.$axios.get('/login-page')

    this.$store.commit('common/SET_LOGIN', { ...data })
    EventBus.$emit('modalLoaded')
  }
}
</script>
<style lang="scss">
.modal {
  &__field {
    &_error {
      &::after {
        position: absolute;
        top: 12px;
        right: 10px;
        width: 20px;
        height: 20px;
        content: '!';
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        text-align: center;
        font-family: $ToyotaType;
        font-weight: bold;
        color: #f02;
        border-radius: 50%;
        border: 2px solid #f02;
      }
      input {
        background-color: #fff !important;
        border: 1px solid #ff0022 !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// components/modals/AppLogInModal.vue